/* eslint-disable react/no-unescaped-entities */
import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { Text, Heading, Flex } from "@baont0209/pibridge_uikit_v20"
import { IsOpenPhisingWaringContext } from "components/Menu";
import { CsFlex, HeaderPi, WrapColumn } from "../styles";

interface PropsHeader {
    pagetitle?:string
    title?:string
    subtitle?:string
    image?:string
}

  
const HeaderPiBridge: React.FC<PropsHeader> = () => {
  const context = useContext(IsOpenPhisingWaringContext);

    return (
        <HeaderPi bgPosition={context.isOpen}>
            <WrapColumn bgPosition={context.isOpen}>
                <CsFlex>
                        <Flex>
                            <TextTitle color='#494949' fontSize='65px' letterSpacing='-0.02em' textTransform='uppercase'>Together we build Pi's world</TextTitle>
                        </Flex> 
                </CsFlex>
            </WrapColumn>
        </HeaderPi>
    )
}
export default HeaderPiBridge

const TextTitle = styled(Text)`
  @media screen and (max-width: 1024px) {
    font-size: 42px;
  }
  @media screen and (max-width: 660px) {
    font-size: 30px;
    text-align: center;
  }
  @media screen and (max-width: 600px) {
    font-size: 25px;
    text-align: center;
  }
`

